import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)"></g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
           L 11, 27
           L 11, 72
           L 50, 95
           L 89, 73
           L 89, 28 z"
      />
    </g>
    <text x="33.7" y="70" fill="currentColor" fontSize="55px" fontFamily="Consolas, serif">
      S
    </text>
  </svg>
);

export default IconLoader;


// import React from 'react';

// const IconLoader = () => (
//   <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
//     <title>Loader Logo</title>
//     <g>
//       <g id="B" transform="translate(11.000000, 5.000000)"></g>
//       <path
//         stroke="currentColor"
//         strokeWidth="5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M 50, 5
//                   L 11, 27
//                   L 11, 72
//                   L 50, 95
//                   L 89, 73
//                   L 89, 28 z"
//       />
//     </g>
//     <text x="33.7" y="70" fill="currentColor" fontSize="55px" fontFamily="Consolas, serif">
//       Y
//     </text>
//   </svg>
// );

// export default IconLoader;